export default "__VITE_PUBLIC_ASSET__c9896d8e__"